import { CondaPepSettings } from '../typings'

function getPepSettings(): CondaPepSettings {
    return window.condaPepSettings
}

export function isRequireAdditionalPepInformationEnabled(): boolean {
    return getPepSettings()?.required_additional_pep_information
}

export function isPastPepOptionShown(): boolean {
    return getPepSettings()?.show_was_politically_exposed_option
}
